import React from "react";
import "./Main.css";
import newImg from '../acepts/uzb_img1.jpg';
import Pop from "../News/Pop";
import { useParams } from "react-router-dom";
import Cards from "../Carts/Cards";

export const videoData = [
  {
    id: 1,
    title: "O'zbekistan",
    dataTime: "02.09.2022",
    img: newImg,
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
  {
    id: 2,
    title: "O'zbekistan",
    dataTime: "02.09.2022",
    img: newImg,
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
];


export default function PhotoPage() {
  return (
    <>
           <main className="containers">
        <div className="row video_page">
          <div className="col-md-9">
            <div className="video_main">
            <img src={newImg} alt="Error img" className="w-100 h-100 object-fit cover" />
               <div className="video_main_text py-4">
               <h3>All News</h3>
               </div>
            </div>
              <div className="my-4 cards_category">
          <Cards />
         </div>
          </div>
          <Pop />
        </div>
       
        <div className="author mt-15">
          <p className="news-info-small">Ғайбуллаева Зилола</p>
        </div>
        <div className="tags">
          <button className="btn-tags fs-6">#Biznes</button>
          <button className="btn-tags fs-6">#London</button>
          <button className="btn-tags fs-6">#Amozon</button>
        </div>
        <div className="theme">
          <div className="img-box"></div>
          <h1 className="news-title"> Мавзуга доир</h1>
        </div>
        {/* <Carousel /> */}
      </main>
    </>
  );
}
